import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;

export interface IUpdateListingInHandParams {
	ListingIds: Array<number>;
	InHand: boolean;
	LocationId?: number;
}

export const { thunk: updateListingInHand, slice: updateListingInHandSlice } = getThunkAndSlice<
	IUpdateListingInHandParams,
	typeof initialState
>({
	initialState,
	path: "/api/Purchasing/UpdateListingInHand",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);

		const listingIds = new Set(params.ListingIds);
		const newData = rootState.pricing.eventInventoryAll.data.map((item) => {
			if (!listingIds.has(item.Listing_ID)) return item;
			return {
				...item,
				InHand: params.InHand,
				InHandDate: params.InHand ? new Date() : item.InHandDate,
			};
		});
		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((item) => {
				if (!listingIds.has(item.Listing_ID)) return item;
				return {
					...item,
					InHand: params.InHand,
					InHandDate: params.InHand ? new Date() : item.InHandDate,
				};
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
